module.exports = __webpack_public_path__ + "img/user.25cabb35.svg";